module.exports = __webpack_public_path__ + "static/media/zhanlue.0a228232.jpg";